﻿"use strict";

export function parseDecimal(value = "") {
    return parseFloat(value.replace(/\s/g, '').replace(',', '.'));
}

export function formatDecimal(value) {
    if (value === "")
        return value;

    if (value === undefined || isNaN(value))
        value = 0;

    value = Math.round(value * 100) / 100;
    var intl = new Intl.NumberFormat("ru-RU", { currency: "RUB" });
    value = intl.format(value);
    if (value.indexOf(',') == -1)
        value += ",00";
    else if (value.indexOf(',') == (value.length - 2))
        value += "0";
    return value.replace(',', '.');
}

export function formatDefault(val) {
    if (val === "")
        return val;

    return val.replace(/\s/g, '').replace(',', '.');

} 